(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ab-base"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__ameliaBloomInit) return;
    window.__ameliaBloomInit = true;

    function labelFor(el) {
      return el.getAttribute('data-ab-interest') || '';
    }

    function setInterest(value) {
      var form = document.getElementById('noriu-suzinoti');
      if (!form) return;
      var tags = form.querySelector('[data-ab-tags]');
      var echo = form.querySelector('[data-ab-echo]');
      var base = tags ? (tags.getAttribute('data-ab-base') || 'amelia-bloom') : 'amelia-bloom';
      if (tags) {
        tags.value = value ? base + ', ' + value : base;
      }
      if (echo) {
        var title = value ? value.replace(/^ab-/, '').replace(/-/g, ' ') : '';
        echo.textContent = title ? 'Domina: ' + title : '';
        echo.hidden = !title;
      }
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-ab-scroll]');
      if (!trigger) return;
      var href = trigger.getAttribute('href') || '#noriu-suzinoti';
      var id = href.replace(/^.*#/, '');
      var target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      setInterest(labelFor(trigger));
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var input = target.querySelector('input[type="email"]');
      if (input) {
        window.setTimeout(function () { input.focus({ preventScroll: true }); }, 500);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["contact-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    var drawer = document.getElementById('rutina-contact-drawer');
    if (!drawer) return;

    function openDrawer() {
      drawer.hidden = false;
      document.body.classList.add('rutina-drawer-open');
      var first = drawer.querySelector('.rutina-drawer__channel');
      if (first) first.focus({ preventScroll: true });
    }
    function closeDrawer() {
      drawer.hidden = true;
      document.body.classList.remove('rutina-drawer-open');
    }

    // Helper: ar nuoroda veda i kontaktų puslapį?
    function isContactLink(a) {
      if (!a || !a.getAttribute) return false;
      var href = a.getAttribute('href');
      if (!href) return false;
      // Atmesti tarpus, target=_blank ir modifier mygtukus tvarko callerys
      // Tikriname tiek pilna URL, tiek relative
      try {
        var url = new URL(href, window.location.origin);
        if (url.origin !== window.location.origin) return false;
        return /\/pages\/contact\/?$/i.test(url.pathname);
      } catch (e) {
        return /(^|\/)pages\/contact\/?($|[?#])/i.test(href);
      }
    }

    document.addEventListener('click', function (e) {
      // Ignoruoti vidurinio/middle ar Ctrl/Cmd paspaudimus (atidaro tab)
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;

      // 1. Mygtukai/elementai su data-contact-drawer-open
      var opener = e.target.closest('[data-contact-drawer-open]');
      if (opener) {
        e.preventDefault();
        openDrawer();
        return;
      }

      // 2. Nuorodos i /pages/contact (meniu, footer, body)
      var link = e.target.closest('a');
      if (link && isContactLink(link)) {
        e.preventDefault();
        openDrawer();
        return;
      }

      // 3. Uzdarymo mygtukai
      var closer = e.target.closest('[data-contact-drawer-close]');
      if (closer && drawer.contains(closer)) {
        e.preventDefault();
        closeDrawer();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) closeDrawer();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lp-base"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.RutinaCart) return;

    var DRAWER_ID = 'rutina-cart-drawer';

    function drawer() {
      return document.getElementById(DRAWER_ID);
    }

    function openDrawer(node) {
      if (!node) return;
      node.hidden = false;
      requestAnimationFrame(function () {
        node.classList.add('is-open');
      });
      document.documentElement.classList.add('has-cart-open');
    }

    function closeDrawer(node) {
      if (!node) return;
      node.classList.remove('is-open');
      document.documentElement.classList.remove('has-cart-open');
      setTimeout(function () {
        node.hidden = true;
      }, 280);
    }

    /* Krepšelio stalčius perpiešiamas iš serverio, kad matytųsi naujos eilutės.
       Originalus cart-drawer.liquid skriptas laiko nuorodą į seną DOM mazgą,
       todėl uždarymą tvarkome patys (deleguoti klausytojai — veikia ir po pakeitimo). */
    function refreshDrawer() {
      var current = drawer();
      if (!current) return Promise.resolve(null);
      return fetch(window.location.pathname, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById(DRAWER_ID);
          if (!fresh) return current;
          fresh.hidden = true;
          fresh.classList.remove('is-open');
          current.replaceWith(fresh);
          return fresh;
        })
        .catch(function () { return drawer(); });
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-close]')) closeDrawer(drawer());
    });
    document.addEventListener('keydown', function (e) {
      var node = drawer();
      if (e.key === 'Escape' && node && !node.hidden) closeDrawer(node);
    });

    function track(event, meta, items) {
      if (!window.dataLayer) return;
      try {
        window.dataLayer.push({
          event: event,
          currency: 'EUR',
          value: (meta && meta.value) || null,
          bundle: (meta && meta.label) || null,
          item_count: items.length
        });
      } catch (err) { /* analitika niekada nestabdo pirkimo */ }
    }

    function permalink(items) {
      return '/cart/' + items.map(function (i) { return i.id + ':' + (i.quantity || 1); }).join(',');
    }

    window.RutinaCart = {
      add: function (items, meta) {
        items = (items || []).filter(function (i) { return i && i.id; });
        if (!items.length) return Promise.resolve(false);

        return fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('cart-add-failed');
            return r.json();
          })
          .then(function () {
            track('add_to_cart', meta, items);
            return refreshDrawer();
          })
          .then(function (node) {
            openDrawer(node);
            return true;
          })
          .catch(function () {
            window.location.href = permalink(items);
            return false;
          });
      }
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lp-chrome"] && !Shopify.designMode) return;
  try {
    (function () {
    /* Krepselio nuoroda atidaro tos pacios temos stalciu; be JS lieka iprastas
       perejimas i /cart, todel niekada nesugenda. */
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest && e.target.closest('[data-lp-cart-open]');
      if (!trigger) return;
      var drawer = document.getElementById('rutina-cart-drawer');
      if (!drawer) return;
      e.preventDefault();
      drawer.hidden = false;
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
      });
      document.documentElement.classList.add('has-cart-open');
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
